import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';
import { CustomerMasterSourceType } from 'models/swagger/customerMasterSourceType';

export const api = {
  getCustomerRequests: (
    url: string,
    assetRefNo?: string,
    caRefNo?: string,
    crType?: string,
    cuRefNo?: string,
    stateList?: string[],
    crSubType?: string,
    taxDocument?: string,
    forceCheck?: boolean
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/customer-requests`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        assetRefNo: assetRefNo,
        caRefNo: caRefNo,
        crSubType: crSubType,
        crType: crType,
        cuRefNo: cuRefNo,
        taxDocument: taxDocument,
        stateList: stateList,
        forceCheck: forceCheck || false,
      },
    }),
};
